export default "__VITE_ASSET__DgndcEUC__";